import { formatCurrencyAmountWithIssue } from '../../../commons/currency/Currency.Functions';
import { connect } from 'react-redux';

// functions
import * as ComponentFunctions from './SettlementTotalItem.Functions';

// styles
import './SettlementTotalItem.Styles.css';

const fmt = (value: number | undefined, currency: string) => formatCurrencyAmountWithIssue(value, currency);

const SettlementTotalItemComponent = (props: ComponentFunctions.Props) => {
    const cur = props.CurrencyCode?.toUpperCase() || 'ARS';

    const totalALiquidar   = props.TotalToSettle    ?? 0;
    const honorariosCentro = props.OwnerAmount        ?? 0;
    const honorariosEquipo = props.TeamAmount         ?? 0;
    const retencionTotal   = props.TotalWithholdings  ?? 0;
    const retencionCentro  = props.OwnerWithholdings  ?? 0;
    const retencionEquipo  = props.TeamWithholdings   ?? 0;
    const totalACobrar     = totalALiquidar - honorariosEquipo - retencionCentro;

    // Al confirmar se puede informar el comprobante real; si vino, se muestra
    // debajo del cálculo para que la diferencia con lo calculado quede a la vista.
    const facturaFija      = props.InvoiceFixedTotal   ?? 0;
    const facturaTotal     = props.InvoiceTotal        ?? 0;
    const facturaRetencion = props.InvoiceTaxRetention ?? 0;
    const facturaNeto      = props.InvoiceTotalToSettle ?? 0;
    const hasInvoice       = [facturaFija, facturaTotal, facturaRetencion, facturaNeto].some((value) => value !== 0);
    const invoiceGross     = facturaTotal || facturaFija;
    const invoiceNet       = facturaNeto || (invoiceGross - facturaRetencion);
    const invoiceDiff      = invoiceNet - totalACobrar;

    return (
        <div className="sti-card">
            <div className="sti-currency-badge">{cur}</div>
            <table className="sti-table">
                <tbody>

                    {/* ── Composición del total a liquidar ────────────── */}
                    <tr className="sti-bruto-row">
                        <td className="sti-label">Total a liquidar</td>
                        <td className="sti-amount">{fmt(totalALiquidar, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Honorarios centro médico</td>
                        <td className="sti-amount">{fmt(honorariosCentro, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Honorarios equipo médico</td>
                        <td className="sti-amount">{fmt(honorariosEquipo, cur)}</td>
                    </tr>

                    {/* ── Composición de la retención ──────────────────── */}
                    <tr className="sti-retention-header">
                        <td className="sti-label">Retención total</td>
                        <td className="sti-amount">{fmt(retencionTotal, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Retención centro médico</td>
                        <td className="sti-amount">{fmt(retencionCentro, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Retención equipo médico</td>
                        <td className="sti-amount">{fmt(retencionEquipo, cur)}</td>
                    </tr>

                    {/* ── Deducciones para el total a cobrar ───────────── */}
                    <tr className="sti-deduct sti-deduct-first">
                        <td className="sti-label">Honorarios equipo médico</td>
                        <td className="sti-amount sti-neg">− {fmt(honorariosEquipo, cur)}</td>
                    </tr>
                    <tr className="sti-deduct">
                        <td className="sti-label">Retención centro médico</td>
                        <td className="sti-amount sti-neg">− {fmt(retencionCentro, cur)}</td>
                    </tr>

                    {/* ── Total a cobrar ───────────────────────────────── */}
                    <tr className="sti-grand-total">
                        <td className="sti-label">Total a cobrar</td>
                        <td className="sti-amount sti-pos">{fmt(totalACobrar, cur)}</td>
                    </tr>

                </tbody>
            </table>

            {hasInvoice && (
                <table className="sti-table sti-invoice">
                    <tbody>
                        <tr className="sti-invoice-header">
                            <td className="sti-label">Según comprobante</td>
                            <td className="sti-amount">{fmt(invoiceGross, cur)}</td>
                        </tr>
                        {facturaFija !== 0 && facturaTotal !== 0 && facturaFija !== facturaTotal && (
                            <tr className="sti-sub">
                                <td className="sti-label">Importe fijado</td>
                                <td className="sti-amount">{fmt(facturaFija, cur)}</td>
                            </tr>
                        )}
                        {facturaRetencion !== 0 && (
                            <tr className="sti-sub">
                                <td className="sti-label">Impuestos y retenciones</td>
                                <td className="sti-amount sti-neg">− {fmt(facturaRetencion, cur)}</td>
                            </tr>
                        )}
                        <tr className="sti-invoice-net">
                            <td className="sti-label">Neto según comprobante</td>
                            <td className="sti-amount">{fmt(invoiceNet, cur)}</td>
                        </tr>
                        {Math.abs(invoiceDiff) >= 0.01 && (
                            <tr className="sti-sub">
                                <td className="sti-label">Diferencia con lo calculado</td>
                                <td className={`sti-amount ${invoiceDiff > 0 ? 'sti-pos' : 'sti-neg'}`}>
                                    {invoiceDiff > 0 ? '+ ' : '− '}{fmt(Math.abs(invoiceDiff), cur)}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementTotalItemComponent as any);